import axios from '@/plugins/axios'


export default {
    state: {
        reportsList: [],
        activeReport: [],
        selectedItemInMenu: []

    },
    mutations: {
        setReportsList(state, reportsList) {
            if(reportsList.length){
                state.reportsList = reportsList.map(
                    (item, index) => {
                        return {
                            type: "report",
                            id: `rep_${index}`,
                            name: item,
                        };
                    }
                );
            }
        },
        addToReportsList(state, item) {
            state.reportsList.push({
                id: state.reportsList.length,
                name: String(item),
                type: "report"
            })
        },
        removeFromReportsList(state, item) {
            let q = state.reportsList.findIndex((el) => {
                return el.name === item
            });
            state.reportsList.splice(q, 1)
        },
        renameReport(state, obj){
            let w = state.reportsList.findIndex((el) => {
                return el.name === obj.oldName
            })
            state.reportsList[w].name = obj.newName
        }
    },
    actions: {
        saveSelectedItemInMenu({state}, data){
            state.selectedItemInMenu = data
        },
        saveActiveReport({state}, data){
            state.activeReport = data
        },
        GetReportNames({ commit }) {
            try {
                return axios
                    .post("http://core.memo.az/mainwindow/GetReportNames", {})
                    .then((res) => {
                        if(res.data.length){
                            commit('setReportsList', res.data)
                        }
                        return res.data
                    })
                    .finally(() => {
                    });
            } catch (e) {
                throw e
            }
        },
        AddReport({ commit }, data) {
            try {
                return axios
                    .post("http://core.memo.az/mainwindow/AddReport", data)
                    .then((res) => {
                        commit('addToReportsList', res.data)
                        return res.data
                    })
                    .finally((res) => {
                    });
            } catch (e) {
                throw e
            }
        },
        addNewsToReport({ commit }, data) {
            axios
                .post(
                    "http://core.memo.az/mainwindow/AddReportDocuments", data)
                .then((res) => {
                    return res.reportsList;
                })
                .finally(() => {});
        },
        DeleteReport({ commit }, data) {
            try {
                return axios
                    .post("http://core.memo.az/mainwindow/DeleteReport", data)
                    .then((res) => {
                        commit('removeFromReportsList', data.reportName)
                        return res.data
                    })
                    .finally((res) => {
                    });
            } catch (e) {
                throw e
            }
        },
        renameReport({commit}, data){
            try{
                axios
                    .post(
                        " http://core.memo.az/mainwindow/RenameReport",
                        data
                    )
                    .then((res) => {
                        commit('renameReport', data)
                        this.news = res.data.news;
                    })
                    .finally(() => {});
            } catch(e){
                throw e
            }
        },
        GenerateReport({ commit }, data) {
            
            try {
                return axios
                    .post("http://core.memo.az/mainwindow/GenerateReport ", data)
                    .then((res) => {
                        return res.data
                    })
                    .finally(() => {
                    });
            } catch (e) {
            }
        }
    },
    getters: {
        reportsList(state) {
            return state.reportsList
        },
        activeReport(state) {
            return state.activeReport
        },
        selectedItemInMenu(state) {
            return state.selectedItemInMenu
        }
    }
}